export const validateUserInput = (value, inputMaxLength) => {
    // Regex to check for emojis
    const emojiRegex = /([\u203C-\u3299]|[\uD83C-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u26FF]|[\u2700-\u27BF])/g;

    // Regex to check for special characters (excluding spaces)
    const specialCharRegex = /[^a-z0-9 .,+\-&$'?""]/i;

    // Check for special characters
    if (specialCharRegex.test(value) || emojiRegex.test(value)) {
        return { isValid: false, errorMessage: `You can only add letters, numbers and spaces.`, sanitizedValue: value.replace(emojiRegex, '').replace(specialCharRegex, '') };
    }

    // Check for maximum length
    if (value.length > inputMaxLength) {
        return { isValid: false, errorMessage: `Maximum length of ${inputMaxLength} characters exceeded.`, sanitizedValue: value.slice(0, inputMaxLength) };
    }

    // If all checks pass
    return { isValid: true, errorMessage: '', sanitizedValue: value };
};
